module.exports = __webpack_public_path__ + "img/globe_blue.a3b0d250.svg";